<template>
  <section class="c-section c-section--home">
    <div class="c-banner" v-if="context.banner">
      <div class="container h-100">
        <div class="c-banner__container">
          <div class="row g-4 h-100">
            <div
              data-aos="fade-right"
              class="col-12 col-lg-6"
            >
              <div class="w-100 h-100 d-flex align-items-center">
                <div v-if="context.banner">
                  <h2 class="white fs-16 w-sbold mb-4" >
                    <span class="fs-21 me-1">
                      <Icon icon="carbon:location"/>
                    </span>
                    {{ context.banner.subtitle }}
                  </h2>
                  <h2 class="fs-35 w-sbold white mb-5">
                    {{ context.banner.title }}
                  </h2>
                  <div class="c-social mb-5" v-if="general.data.information">
                    <a
                      v-if="general.data.information.social.facebook"
                      :href="general.data.information.social.facebook"
                      target="_blank"
                      class="c-social__link me-2"
                    >
                      <Icon icon="ri:facebook-fill"/>
                    </a>
                    <a
                      v-if="general.data.information.social.youtube"
                      :href="general.data.information.social.youtube"
                      target="_blank"
                      class="c-social__link me-2"
                    >
                      <Icon icon="ph:youtube-logo-fill"/>
                    </a>
                    <a
                      v-if="general.data.information.social.linkedin"
                      :href="general.data.information.social.linkedin"
                      target="_blank"
                      class="c-social__link me-2"
                    >
                      <Icon icon="ri:linkedin-fill"/>
                    </a>
                    <a
                      v-if="general.data.information.social.tiktok"
                      :href="general.data.information.social.tiktok"
                      target="_blank"
                      class="c-social__link me-2"
                    >
                      <Icon icon="ic:baseline-tiktok"/>
                    </a>
                    <a
                      v-if="general.data.information.social.instagram"
                      :href="general.data.information.social.instagram"
                      target="_blank"
                      class="c-social__link"
                    >
                      <Icon icon="mdi:instagram"/>
                    </a>
                  </div>
                  <div class="d-flex" v-if="context.banner">
                    <a
                      target="_blank"
                      :href="context.banner.button.link"
                      class="c-button c-button--warning d-flex align-items-center py-1"
                    >
                      {{ context.banner.button.title }}
                      <span class="ms-2 fs-25">
                        <Icon icon="nimbus:gift-box"/>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-aos="fade-left"
              class="col-12 col-lg-6 d-flex align-items-center"
            >
              <formulary v-if="!contextLoading"></formulary>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="context.banner"
        id="slider-banner-top"
        class="c-slider-banner-top swiper h-100"
      >
        <div class="swiper-wrapper position-relative">
          <div
            class="swiper-slide"
              v-for="(slideBanner, islideBanner) of context.banner.background"
              :key="`welcome-slide-${islideBanner}`"
          >
          <figure class="c-banner__background">
            <img :src="slideBanner" alt="" class="w-100 h-100 of--cover">
          </figure>
          </div>
        </div>
      </div>
      <div class="c-banner__layer"></div>
    </div>
    <div class="c-visit py-5" v-if="context.oportunidad">
      <div class="container">
        <div class="row g-4">
          <div data-aos="fade-right" class="col-12 col-lg-6">
            <div class="c-visit__images">
              <figure class="c-visit__left" v-if="context.oportunidad">
                <img
                  :src="context.oportunidad.bottom_image"
                  alt=""
                  class="w-100 h-100 of--cover"
                >
              </figure>
              <figure class="c-visit__top" v-if="context.oportunidad">
                <img
                  :src="context.oportunidad.little_image"
                  alt=""
                  class="w-100 h-100 of--cover"
                >
              </figure>
              <figure class="c-visit__right" v-if="context.oportunidad">
                <img :src="context.oportunidad.vertical_image" alt="" class="w-100 h-100 of--cover">
              </figure>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="c-visit__texts" v-if="context.oportunidad">
              <div
                data-aos="fade-right"
                class="d-flex mb-2"
              >
                <h2 class="backgraund-pri-light">
                  <span class="d-flex me-1">
                    <Icon icon="ic:round-arrow-back-ios"/>
                  </span>
                  {{ context.oportunidad.subtitle }}
                </h2>
              </div>
              <h2
                data-aos="fade-right"
                class="gray-black fs-35 w-sbold mb-4"
              >
                {{ context.oportunidad.title }}
              </h2>
              <p
                data-aos="fade-right"
                class="c-visit__text mb-2" v-html="context.oportunidad.description"
              >
              </p>
              <div
                data-aos="fade-right"
                class="d-flex"
              >
                <a
                  target="_blank"
                  :href="wspContactButton"
                  class="c-button c-button--primary py-1"
                >
                  <span class="fs-21 me-1">
                    <Icon icon="ic:baseline-whatsapp"/>
                  </span>
                  {{ context.oportunidad.contact_button }}
                </a>
              </div>
              <figure class="c-visit__circles">
                <img
                  src="@/assets/images/circles-pri-light.png"
                  alt=""
                  class="h-100 w-100 of--contain"
                >
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="c-banner-medium mb-5" v-if="context.video">
      <div class="container h-100">
        <div class="c-banner-medium__texts text-center" v-if="context.video">
          <h2
            data-aos="fade-up"
            class="white fs-35 w-sbold mb-5"
          >
            {{ context.video.title }}
          </h2>
          <button
            data-aos="fade-up"
            class="c-button-play" @click="openVideoBannerMedium()"
          >
            <Icon icon="ph:play"/>
          </button>
        </div>
      </div>
      <figure class="c-banner-medium__figure" v-if="context.video">
        <img
          :src="context.video.background"
          alt=""
          class="w-100 h-100 of--cover"
        >
      </figure>
      <div class="c-banner-medium__background"></div>
    </div>
    <div class="container mb-5">
      <div class="overflow-hidden pb-md-5" v-if="context.videos">
        <div class="row justify-content-center">
          <div class="col-10 col-md-5">
            <div class="d-flex flex-column align-items-center">
              <h2 data-aos="fade-up" class="backgraund-pri-light">
                <span class="d-flex me-1">
                  <Icon icon="mingcute:play-circle-line"/>
                </span>
                {{ context.videos.subtitle }}
              </h2>
              <h2 data-aos="fade-up" class="fs-35 w-sbold gray-black text-center">
                {{ context.videos.title }}
              </h2>
            </div>
          </div>
        </div>
        <VideosCarousel v-if="context.videos" :list="context.videos.videos"></VideosCarousel>
      </div>
    </div>
    <div id="proyecto" class="c-about-proyect mb-5" v-if="context.project">
      <div class="container">
        <div class="row gx-0 gy-5">
          <div class="col-12 col-lg-5">
            <div
              v-if="context.project"
              class="c-about-proyect__block-white d-flex flex-column align-items-start"
            >
              <div data-aos="fade-right" class="d-flex mb-2">
                <h2 class="backgraund-pri-light">
                  <span class="d-flex me-1">
                    <Icon icon="ic:round-arrow-back-ios"/>
                  </span>
                  {{ context.project.subtitle }}
                </h2>
              </div>
              <h2 data-aos="fade-right" class="gray-black fs-35 w-sbold mb-4">
              {{ context.project.title }}
              </h2>
              <p
                data-aos="fade-right"
                class="fs-16 w-regular gray-medium mb-4"
                v-html="context.project.description"
              >
              </p>
              <div
                data-aos="fade-right"
                class="row gy-4"
              >
                <div class="col-12 col-md-6"
                  v-for="(listProject, ilistProject) of context.project.benefits"
                  :key="`benefic-projects-${ilistProject}`"
                >
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <figure class="c-about-proyect__icon">
                        <img
                          :src="listProject.icon"
                          alt=""
                          class="w-100 h-100 of--contain"
                        >
                      </figure>
                    </div>
                    <p class="fs-14 mb-0 gray-medium w-sbold">
                      {{ listProject.text }}
                    </p>
                  </div>
                </div>
              </div>
              <a
                data-aos="fade-right"
                target="_blank"
                :href="general.data.information.brochure.url"
                class="c-button c-button--primary mt-4 d-flex justify-content-center
                  align-items-center"
              >
                <span class="fs-21 me-2 d-flex">
                  <Icon icon="octicon:paperclip-16"/>
                </span>
                {{ context.project.boton_brochure }}
              </a>
            </div>
          </div>
          <div class="col-12 col-lg-7">
            <div class="c-about-proyect__images" v-if="context.project">
              <div
                style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff"
                class="proyect-gallery"
              >
                <div class="swiper-wrapper">
                  <div class="swiper-slide"
                    v-for="(imagen, iimagen) of context.project.gallery"
                    :key="`imagen-grande-${iimagen}`"
                  >
                    <img :src="imagen.url" />
                  </div>
                </div>
              </div>
              <div class="proyect-gallery-images">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"
                    v-for="(imagen, iimagenes) of context.project.gallery"
                    :key="`imagenes-gallerys-${iimagenes}`"
                  >
                    <div class="d-flex flex-column w-100">
                      <figure class="c-about-proyect__thumb w-100">
                        <img :src="imagen.url" class="w-100 h-100 of--cover" />
                      </figure>
                      <p
                        v-if="context.project.show_captions"
                        class="fs-14 black w-medium py-2 mb-0">
                        {{ imagen.title }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="tipologia" class="c-typology py-5" v-if="context.tipologia">
      <div class="container">
        <div class="row gy-4 justify-content-center">
          <div
            data-aos="fade-up"
            class="col-12"
            :class="{ 'col-lg-6': context.tiopologia_design === 'horizontal' }">
            <div class="c-typology__container mb-5">
              <div class="c-typology__images">
                <figure class="c-typology__image">
                  <img :src="context.tipologia.image" alt="" class="w-100 h-100 of--cover">
                </figure>
                <div class="c-typology__border"></div>
              </div>
              <figure class="c-typology__circles">
                <img
                  src="@/assets/images/circles-warning-hr.png"
                  alt=""
                  class="w-100 h-100 of--cover"
                >
              </figure>
            </div>
          </div>
          <div class="col-8" :class="{ 'col-lg-6': context.tiopologia_design === 'horizontal' }">
            <div
              v-if="context.tipologia"
              data-aos="fade-up"
              data-aos-delay="200"
              class="d-flex mb-2"
              :class="{ 'justify-content-center': context.tiopologia_design === 'vertical' }"
            >
              <h2 class="backgraund-pri-light mb-4">
                <span class="d-flex me-1">
                  <Icon icon="ic:round-arrow-back-ios"/>
                </span>
                {{ context.tipologia.subtitle }}
              </h2>
            </div>
            <h2
              data-aos="fade-up"
              data-aos-delay="200"
              class="gray-black fs-35 w-sbold mb-0"
              :class="{ 'text-center': context.tiopologia_design === 'vertical' }"
            >
              {{ context.tipologia.title }}
            </h2>
            <p
              data-aos="fade-up"
              data-aos-delay="200"
              class="gray-medium fs-18 w-regular mb-4"
              :class="{ 'text-center': context.tiopologia_design === 'vertical' }"
            >
              <span class="fs-21">
                <Icon icon="material-symbols:location-on-outline-rounded"/>
              </span>
              {{ context.tipologia.location }}
            </p>
            <p
              data-aos="fade-up"
              data-aos-delay="200"
              v-html="context.tipologia.description"
              class="gray-medium fs-16 w-regular mb-4"
              :class="{ 'text-center': context.tiopologia_design === 'vertical' }"
            >
            </p>
            <div data-aos="fade-up" data-aos-delay="200" class="row justify-content-center gy-5">
              <div
                class="col-12 col-md-6"
                :class="{ 'col-lg-4': context.tiopologia_design === 'vertical' }"
                v-for="(tipoBenef, itipoBenef) of context.tipologia.benefits"
                :key="`tipologia-beneficios-${itipoBenef}`"
              >
                <div class="d-flex align-items-center">
                  <div class="me-3">
                    <figure class="c-about-proyect__icon">
                      <img
                        :src="tipoBenef.icon"
                        alt=""
                        class="w-100 h-100 of--contain"
                      >
                    </figure>
                  </div>
                  <p class="fs-14 mb-0 gray-medium w-sbold">
                    {{ tipoBenef.text }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="mt-4"
              :class="{ 'd-flex justify-content-center':
                context.tiopologia_design === 'vertical'
              }"
            >
              <a
                v-if="context.tipologia"
                :href="wspContactButton"
                target="_blank"
                class="c-button c-button--primary py-1"
              >
                <span class="fs-21 me-1">
                  <Icon icon="ri:whatsapp-line"/>
                </span>
                {{ context.tipologia.contact_button.title }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="galeria" class="c-gallery py-5" v-if="context.gallery">
      <div class="container">
        <h2 data-aos="fade-up" class="text-center mb-4 sec-color fs-14 w-sbold 2">
          {{ context.gallery.subtitle }}
        </h2>
        <h2 data-aos="fade-up" class="text-center gray-black fs-35 w-sbold mb-5">
          {{ context.gallery.title }}
        </h2>
        <div class="c-gallery__container">
          <div
            class="c-gallery__top"
          >
            <div
              v-if="context.gallery.gallery.areas_comunes"
              data-aos="fade-up"
              data-aos-delay="200"
              class="c-gallery__top-image-1 mb-2 mb-md-0"
            >
              <Fancybox
                class="w-100 h-100"
                :options="{
                  Carousel: {
                    infinite: false,
                  },
                }"
              >
                <a data-fancybox="gallery" :href="comunes" class="c-capa__link"
                  v-for="(comunes, icomunes) of context.gallery.gallery.areas_comunes"
                  :key="`areas-comunes-${icomunes}`"
                >
                  <img :src="comunes" class="w-100 h-100 of--cover" />
                  <div class="c-capa">
                    <div class="c-capa__agregar mb-5">
                      <span>+</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100 p-4">
                      <div class="d-flex align-items-center">
                        <figure class="c-capa__icon me-3">
                          <img
                            src="@/assets/images/comunes.png"
                            alt=""
                            class="w-100 h-100 of--contain"
                          >
                        </figure>
                        <p class="mb-0 fs-21 w-sbold white">
                          Áreas Comunes
                        </p>
                      </div>
                      <p class="mb-0 fs-25 w-sbold white d-flex align-items-center">
                        {{ context.gallery.gallery.areas_comunes.length }}
                        <span class="d-flex ms-2">
                          <Icon icon="heroicons-outline:collection"/>
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
              </Fancybox>
            </div>
            <div
              v-if="context.gallery.gallery.areas_lavado"
              data-aos="fade-up"
              data-aos-delay="200"
              class="c-gallery__top-image-2 mb-2 mb-md-0"
            >
              <Fancybox
                class="w-100 h-100"
                :options="{
                  Carousel: {
                    infinite: false,
                  },
                }"
              >
                <a data-fancybox="gallery" :href="lavado" class="c-capa__link"
                  v-for="(lavado, ilavado) of context.gallery.gallery.areas_lavado"
                  :key="`areas-comunes-${ilavado}`"
                >
                  <img :src="lavado" class="w-100 h-100 of--cover" />
                  <div class="c-capa">
                    <div class="c-capa__agregar mb-5">
                      <span>+</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100 p-4">
                      <div class="d-flex align-items-center">
                        <figure class="c-capa__icon me-3">
                          <img
                            src="@/assets/images/lavado.png"
                            alt=""
                            class="w-100 h-100 of--contain"
                          >
                        </figure>
                        <p class="mb-0 fs-21 w-sbold white">
                          Áreas de Lavado
                        </p>
                      </div>
                      <p class="mb-0 fs-25 w-sbold white d-flex align-items-center">
                        {{ context.gallery.gallery.areas_lavado.length }}
                        <span class="d-flex ms-2">
                          <Icon icon="heroicons-outline:collection"/>
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
              </Fancybox>
            </div>
            <div
              v-if="context.gallery.gallery.bano"
              data-aos="fade-up"
              data-aos-delay="200"
              class="c-gallery__top-image-3 mb-2 mb-md-0"
            >
              <Fancybox
                class="w-100 h-100"
                :options="{
                  Carousel: {
                    infinite: false,
                  },
                }"
              >
                <a data-fancybox="gallery" :href="baño" class="c-capa__link"
                  v-for="(baño, ibaño) of context.gallery.gallery.bano"
                  :key="`baño-${ibaño}`"
                >
                  <img :src="baño" class="w-100 h-100 of--cover" />
                  <div class="c-capa">
                    <div class="c-capa__agregar mb-5">
                      <span>+</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100 p-4">
                      <div class="d-flex align-items-center">
                        <figure class="c-capa__icon me-3">
                          <img
                            src="@/assets/images/baño.png"
                            alt=""
                            class="w-100 h-100 of--contain"
                          >
                        </figure>
                        <p class="mb-0 fs-21 w-sbold white">
                          Baño
                        </p>
                      </div>
                      <p class="mb-0 fs-25 w-sbold white d-flex align-items-center">
                        {{ context.gallery.gallery.bano.length }}
                        <span class="d-flex ms-2">
                          <Icon icon="heroicons-outline:collection"/>
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
              </Fancybox>
            </div>
          </div>
          <div class="c-gallery__medium">
            <div
              class="c-gallery__medium-image-1 mb-2 mb-md-0"
              v-if="context.gallery.gallery.cocina"
            >
              <Fancybox
                class="w-100 h-100"
                :options="{
                  Carousel: {
                    infinite: false,
                  },
                }"
              >
                <a data-fancybox="gallery" :href="cocina" class="c-capa__link"
                  v-for="(cocina, icocina) of context.gallery.gallery.cocina"
                  :key="`cocina-${icocina}`"
                >
                  <img :src="cocina" class="w-100 h-100 of--cover" />
                  <div class="c-capa">
                    <div class="c-capa__agregar mb-5">
                      <span>+</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100 p-4">
                      <div class="d-flex align-items-center">
                        <figure class="c-capa__icon me-3">
                          <img
                            src="@/assets/images/cocina.png"
                            alt=""
                            class="w-100 h-100 of--contain"
                          >
                        </figure>
                        <p class="mb-0 fs-21 w-sbold white">
                          Cocina
                        </p>
                      </div>
                      <p class="mb-0 fs-25 w-sbold white d-flex align-items-center">
                        {{ context.gallery.gallery.cocina.length }}
                        <span class="d-flex ms-2">
                          <Icon icon="heroicons-outline:collection"/>
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
              </Fancybox>
            </div>
            <div
              class="c-gallery__medium-image-2 mb-2 mb-md-0"
              v-if="context.gallery.gallery.dormitorip_principal"
            >
              <Fancybox
                class="w-100 h-100"
                :options="{
                  Carousel: {
                    infinite: false,
                  },
                }"
              >
                <a data-fancybox="gallery" :href="principal" class="c-capa__link"
                  v-for="(principal, iprincipal) of context.gallery.gallery.dormitorip_principal"
                  :key="`dormitorio-principal-${iprincipal}`"
                >
                  <img :src="principal" class="w-100 h-100 of--cover" />
                  <div class="c-capa">
                    <div class="c-capa__agregar mb-5">
                      <span>+</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100 p-4">
                      <div class="d-flex align-items-center">
                        <figure class="c-capa__icon me-3">
                          <img
                            src="@/assets/images/principal.png"
                            alt=""
                            class="w-100 h-100 of--contain"
                          >
                        </figure>
                        <p class="mb-0 fs-21 w-sbold white">
                          Dormitorio Principal
                        </p>
                      </div>
                      <p class="mb-0 fs-25 w-sbold white d-flex align-items-center">
                        {{ context.gallery.gallery.dormitorip_principal.length }}
                        <span class="d-flex ms-2">
                          <Icon icon="heroicons-outline:collection"/>
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
              </Fancybox>
            </div>
          </div>
          <div class="c-gallery__bot">
            <div
              class="c-gallery__bot-image-1 mb-2 mb-md-0"
              v-if="context.gallery.gallery.dormitorio_secundario"
            >
              <Fancybox
                class="w-100 h-100"
                :options="{
                  Carousel: {
                    infinite: false,
                  },
                }"
              >
                <a data-fancybox="gallery" :href="secundario" class="c-capa__link"
                  v-for="(secundario, isecundario) of context.gallery.gallery.dormitorio_secundario"
                  :key="`dormitorio-secundario-${isecundario}`"
                >
                  <img :src="secundario" class="w-100 h-100 of--cover" />
                  <div class="c-capa">
                    <div class="c-capa__agregar mb-5">
                      <span>+</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100 p-4">
                      <div class="d-flex align-items-center">
                        <figure class="c-capa__icon me-3">
                          <img
                            src="@/assets/images/principal.png"
                            alt=""
                            class="w-100 h-100 of--contain"
                          >
                        </figure>
                        <p class="mb-0 fs-21 w-sbold white">
                          Dormitorio Secundario
                        </p>
                      </div>
                      <p class="mb-0 fs-25 w-sbold white d-flex align-items-center">
                        {{ context.gallery.gallery.dormitorio_secundario.length }}
                        <span class="d-flex ms-2">
                          <Icon icon="heroicons-outline:collection"/>
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
              </Fancybox>
            </div>
            <div
              class="c-gallery__bot-image-1"
              v-if="context.gallery.gallery.sala_comedor"
            >
              <Fancybox
                class="w-100 h-100"
                :options="{
                  Carousel: {
                    infinite: false,
                  },
                }"
              >
                <a data-fancybox="gallery" :href="comedor" class="c-capa__link"
                  v-for="(comedor, icomedor) of context.gallery.gallery.sala_comedor"
                  :key="`sala-comedor-${icomedor}`"
                >
                  <img :src="comedor" class="w-100 h-100 of--cover" />
                  <div class="c-capa">
                    <div class="c-capa__agregar mb-5">
                      <span>+</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between w-100 p-4">
                      <div class="d-flex align-items-center">
                        <figure class="c-capa__icon me-3">
                          <img
                            src="@/assets/images/comunes.png"
                            alt=""
                            class="w-100 h-100 of--contain"
                          >
                        </figure>
                        <p class="mb-0 fs-21 w-sbold white">
                          Sala-Comedor
                        </p>
                      </div>
                      <p class="mb-0 fs-25 w-sbold white d-flex align-items-center">
                        {{ context.gallery.gallery.sala_comedor.length }}
                        <span class="d-flex ms-2">
                          <Icon icon="heroicons-outline:collection"/>
                        </span>
                      </p>
                    </div>
                  </div>
                </a>
              </Fancybox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="ubicacion" class="c-maps py-5" v-if="context.visit_us">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <h2 class="c-pink-title text-center fs-35 w-sbold mb-5">
              {{ context.visit_us.title }}
            </h2>
            <div class="c-maps__container mb-4">
              <div class="c-maps__maps" v-html="context.visit_us.mapa">
              </div>
              <div class="c-maps__background"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a
      v-if="wspButton"
      target="_blank"
      :href="wspButton"
      class="c-link-wasap"
    >
      <div class="position-relative">
        <p class="mb-0 white fs-14 w-sbold">
          WhatsApp
        </p>
        <p class="mb-0 fs-12 white w-sbold">
          ¡Click Aquí!
        </p>
        <figure class="c-link-wasap__icon">
          <img src="@/assets/images/link-wasap.png" alt="" class="w-100 h-100 of--cover">
        </figure>
      </div>
    </a>

    <b-modal
      id="modalPlayVideo"
      hide-footer
      hide-header
      hide-actions
      size="xl"
      centered
    >
      <div class="c-modal-descubre c-video-play" v-if="context.video">
        <div class="c-video c-video-player">
          <div
            v-html="context.video.video"
          ></div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import {
  Swiper,
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
} from 'swiper';
import { mapState, mapActions } from 'vuex';
import { Icon } from '@iconify/vue2';
import {
  required,
  requiredIf,
  minLength,
  helpers,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      context: {},
      contextLoading: true,

      selected: null,

      sliderBannerTop: null,

      videoPlayerMedium: null,
      swiper: null,

      name: '',
      email: '',
      attachment: '',
      submitStatus: '',
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(4),
    },
    email: {
      required,
      alpha: helpers.regex('alpha', /.+@.+\..+/),
    },
    attachment: {
      file: {
        required: requiredIf(function file() {
          return this.attachment.length === 0;
        }),
      },
    },
  },
  computed: {
    ...mapState(['general']),

    wspButton() {
      return (this.general.data.information.message_whatsapp_enable)
        ? `https://api.whatsapp.com/send?phone=${this.general.data.information.phone}&text=${this.general.data.information.message_whatsapp}`
        : '';
    },

    wspContactButton() {
      return (this.general.data.information)
        ? `https://api.whatsapp.com/send?phone=${this.general.data.information.phone}&text=${this.general.data.information.message_whatsapp}`
        : '';
    },
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'home' });
  },
  watch: {
    contextLoading(state) {
      if (!state) {
        this.initBannerTopSlider();
        this.initSliderProjectGallery();
        this.traer();
      }
    },
  },
  components: {
    Icon,
    formulary: () => import(/* webpackChunkName: 'formulary' */ '../components/Formulary.vue'),
    VideosCarousel: () => import(/* webpackChunkName: 'videos-carousel' */ '../components/VideosCarousel.vue'),
    Fancybox: () => import(/* webpackChunkName: 'fancybox' */ '../components/Fancybox.vue'),
  },
  methods: {
    ...mapActions(['form']),

    traer() {
      this.selected = this.context.visit_us;
    },

    initBannerTopSlider() {
      window.setTimeout(() => {
        this.sliderBannerTop = new Swiper('#slider-banner-top', {
          modules: [Navigation, Pagination, Autoplay],

          speed: 1500,
          loop: true,
          spaceBetween: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          pagination: {
            el: '#slider-banner-top .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },

          navigation: {
            prevEl: '#slider-banner-top-prev',
            nextEl: '#slider-banner-top-next',
          },
        });
      }, 1000);
    },
    openVideoBannerMedium() {
      window.setTimeout(() => {
        if (this.context.video.video) {
          this.$bvModal.show('modalPlayVideo');
        }
      }, 100);
    },
    initSliderProjectGallery() {
      window.setTimeout(() => {
        this.swiper = new Swiper('.proyect-gallery-images', {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            320: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
          },
        });

        this.swiper2 = new Swiper('.proyect-gallery', {
          modules: [Thumbs, Autoplay],
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: this.swiper,
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      }, 100);
    },
  },
};
</script>
